import React from "react";
import Fa from 'react-fontawesome'
import Header from './Header'

export default class ErrorView extends React.Component {


  render() {
	let errormsg = this.props.location.info || 'unknown'

    return (
      <div>
      	<Header/>
		<div className="container-fluid  x-container-fluid">
	        <div className="row">
	          <div className ="col-md-12">
	            <div className="alert alert-danger" role="alert">
	              <Fa name='exclamation-triangle' />&nbsp;
	              Something went wrong...<p> Error: {errormsg} <br/> Please <a onClick={() => this.props.history.push("/")}>click here</a> to try again. If the error persists, please contact our support team</p>
	            </div>
	          </div>
	        </div>
	    </div>  

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorView.js